import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { alpha } from '@mui/system';

type StyledCountProps = {
  portfolioItemColor: string | null;
};

const StyledCount = styled('li')<StyledCountProps>(
  ({ theme }) => ({
    marginBottom: 4,
    padding: '5px 8px',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.selected,
    borderRadius: 4,
  }),
  ({ theme, portfolioItemColor }) => {
    if (portfolioItemColor === null) {
      return;
    }

    const countColor = theme.palette.getContrastText(portfolioItemColor);

    return {
      color: countColor,
      backgroundColor: alpha(countColor, countColor === '#fff' ? 0.3 : 0.1),
    };
  },
  addHighContrastStyles(({ theme }) => ({
    paddingTop: 4,
    paddingBottom: 4,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.divider}`,
  })),
);

type HiddenTagsCountProps = {
  count: number;
  portfolioItemColor: string | null;
};

const HiddenTagsCount = ({
  count,
  portfolioItemColor,
}: HiddenTagsCountProps) => (
  <StyledCount portfolioItemColor={portfolioItemColor}>+{count}</StyledCount>
);

export default HiddenTagsCount;
